"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferDetailsTitleGallery = void 0;
var OfferDetailsTitleGallery_1 = require("./OfferDetailsTitleGallery");
Object.defineProperty(exports, "OfferDetailsTitleGallery", { enumerable: true, get: function () { return OfferDetailsTitleGallery_1.OfferDetailsTitleGallery; } });
